import { Box, Container, Typography, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const Ads = () => {
  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        background:
          "linear-gradient(180deg, rgba(13, 71, 255, 0.04) 0%, rgba(13, 71, 255, 0) 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Decorative dots pattern */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "300px",
          height: "300px",
          opacity: 0.5,
          background:
            "radial-gradient(circle, rgba(13, 71, 255, 0.1) 1px, transparent 1px)",
          backgroundSize: "20px 20px",
        }}
      />

      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", md: "center" },
            gap: { xs: 4, md: 8 },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "32px", md: "48px" },
                fontWeight: 600,
                mb: 2,
              }}
            >
              Ready to Innovate Together?
            </Typography>
            <Typography
              sx={{
                fontSize: "18px",
                color: "rgba(0, 0, 0, 0.7)",
                maxWidth: "640px",
              }}
            >
              Whether you're looking to launch a new DeFi protocol, optimize
              yield strategies, or leverage AI for smarter financial solutions,
              b11a is your trusted partner.
            </Typography>
          </Box>

          <Button
            variant="contained"
            endIcon={<ArrowForwardIcon />}
            sx={{
              bgcolor: "#0D47FF",
              color: "white",
              py: 2,
              px: 4,
              fontSize: "16px",
              fontWeight: 500,
              textTransform: "none",
              "&:hover": {
                bgcolor: "#0035CC",
              },
            }}
          >
            Let's Talk DeFi
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Ads;
